import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
} from "@angular/core";
import { ActivatedRoute, Router, UrlSegment } from "@angular/router";
import { QuestionListService } from "@app/core/services/question-list.service";
import { TableFilter } from "@app/shared/models/table-filter";

const FILTER_PAG_REGEX = /[^0-9]/g;

@Component({
  selector: "pagination",
  templateUrl: "./pagination.component.html",
  styleUrls: ["./pagination.component.css"],
})
export class PaginationComponent implements OnInit {
  @Input() tableFilter: TableFilter;
  @Input() totalCount;
  @Input() pageSize;
  @Output() getPage: any = new EventEmitter<any>();
  @Input() page;

  public pageLists: any;
  public numOfPage: any;
  public enterPage: any;
  public pageFrom: any;
  public pageTo: any;

  constructor(private _activeRoute: ActivatedRoute, private _router: Router) {}

  ngOnInit() {
    if (this.tableFilter) {
      this.page = this.tableFilter.page ? this.tableFilter.page : 1;
      this.enterPage = parseInt(this.page);
      this.pageSize = this.tableFilter.limit ? this.tableFilter.limit : 10;
      this.totalCount = this.tableFilter.totalCount;
    } else {
      this._activeRoute.queryParams.subscribe((params) => {
        this.page = params.page ? params.page : 1;
        this.enterPage = parseInt(this.page);
        this.pageSize = params.limit ? params.limit : 10;
      });
    }
    this.getPageLabel(this.totalCount, this.pageSize, this.page - 1);
    this.numOfPage = this.getNumberOfPages();
    this.pageLists = this.getPagingRange(this.page, {
      min: 1,
      total: this.numOfPage,
      length: this.numOfPage,
    });
  }

  getNumberOfPages() {
    return Math.ceil(this.totalCount / this.pageSize);
  }

  getPagingRange(current, { min = 1, total = 20, length = 5 } = {}) {
    if (length > total) length = total;

    let start = current - Math.floor(length / 2);
    start = Math.max(start, min);
    start = Math.min(start, min + total - length);

    return Array.from({ length: length }, (el, i) => start + i);
  }

  onenterpage() {
    console.log("enter page");
    if (this.pageLists.includes(parseInt(this.enterPage))) {
      this.page = this.enterPage;
      if (this.tableFilter) this.getPage.emit(this.page);
      else
        this._router.navigate([], {
          queryParams: { page: this.page, limit: this.pageSize },
          queryParamsHandling: "merge",
        });
    } else {
      this.enterPage = this.page;
    }
  }

  goFirst() {
    this.enterPage = 1;
    this.onenterpage();
  }

  goLast() {
    this.enterPage = this.numOfPage;
    this.onenterpage();
  }

  goNext(isAllow: boolean) {
    if (isAllow) {
      this.enterPage += 1;
      this.onenterpage();
    }
  }

  goPrev(isAllow: boolean) {
    if (isAllow) {
      this.enterPage -= 1;
      this.onenterpage();
    }
  }

  getPageLabel(total: any, pageSize, pageNr) {
    const start = Math.max(this.getPageStart(pageSize, pageNr), 0);
    const end = Math.min(this.getPageStart(pageSize, pageNr + 1), total);
    this.pageFrom = start + 1;
    this.pageTo = end;
  }

  getPageStart(pageSize, pageNr) {
    return pageSize * pageNr;
  }
}
